module.exports = __webpack_public_path__ + "media/images/error404-4319153e05987db161bae64cf742efc3.svg";